import { useSelector } from 'react-redux';
import { ROUTE } from 'routers/data';
import PrivateRoute from 'components/privateRoute';

type TSecurity = {
  direction: 'forward' | 'backward';
};
export const Security = ({ direction }: TSecurity) => {
  const isLogged = useSelector((state: any) => state.profile?.isLogged);

  return (
    <>
      {direction === 'backward' && (
        <PrivateRoute allowed={!isLogged} redirect={ROUTE.profileStatus} />
      )}
      {direction === 'forward' && (
        <PrivateRoute allowed={isLogged} redirect={ROUTE.login} />
      )}
    </>
  );
};
